import React from 'react';

import { FormattedMessage, useIntl } from 'react-intl-next';

import SectionMessage from '@atlaskit/section-message';

import { useFetchPendingReviewers } from '../../hooks/use-fetch-pending-reviewers';

import messages from './merge-dialog.i18n';

export default function PendingReviewersInfo(): JSX.Element | null {
  const { users, loading, error } = useFetchPendingReviewers();
  const { formatMessage } = useIntl();

  // we don't need to handle and loading or error states here.
  // we only want to render this section message if the pending
  // reviewers request is successful.
  if (!loading && !error && users && users.length > 0) {
    return (
      <SectionMessage
        testId="pending-reviewers-info"
        title={formatMessage(messages.pendingReviewersTitle)}
      >
        <FormattedMessage tagName="p" {...messages.pendingReviewersSubtitle} />
        <ul>
          {users?.map(usr => (
            <li key={usr.uuid}>{usr.display_name}</li>
          ))}
        </ul>
      </SectionMessage>
    );
  }

  return null;
}
